import update from 'immutability-helper';

export default function clearFilterSelection(state, action) {
  // console.log('CLEAR_FEATURE_SELECTION...', action)

  // iterate the filtered features adding and removing the selected flag.
  for (let [index, feature] of state.feedData.entries()) {
    let flag = false;

    state = update(state, {
      feedData: {
        [index]: {
          _selected: {
            $set: flag,
          },
        },
      },
    });
  }

  return update(state, {
    feedDataSelectedIndex: {
      $set: null,
    },
  });
}
